import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ListSubject() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { examId, subjectId } = location.state || {};
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [facultyList, setFacultyList] = useState([]);
  const [rowFacultyAssignments, setRowFacultyAssignments] = useState({});

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
    fetchFacultyList();
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    const data = {
      examId: examId,
      subjectId: subjectId,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/reAssessment/faculty/details/list`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
          maxBodyLength: Infinity,
        }
      );

      // Initialize rowFacultyAssignments with reAssfacultyId
      const assignments = response.data.students.reduce((acc, student) => {
        acc[student.id] = student.reAssfacultyId;
        return acc;
      }, {});

      setRecords(response.data.students);
      setRowFacultyAssignments(assignments);
      setLoading(false);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching records:', error);
      setLoading(false);
    }
  };

  // function to fetch faculty list for the selected
  const fetchFacultyList = async () => {
    const token = localStorage.getItem('token');
    try {
      let data = JSON.stringify({
        subjectId: subjectId,
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/faculty/list-faculty`,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        data: data,
      };

      const response = await axios.request(config);

      // Setting faculties from the response, assuming 'faculties' is the key
      setFacultyList(response.data.faculties || []);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching faculty list:', error);
      setFacultyList([]); // Fallback to empty array in case of error
    }
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '50px',
      center: 'true',
    },
    {
      name: 'Roll Number',
      selector: (row) => row.rollNumber,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },

    {
      name: 'Assign Reassessment',
      width: '200px',
      center: 'true',
      cell: (row) => (
        <div className="col-md-8">
          <select
            className="form-select form-select-sm"
            value={rowFacultyAssignments[row.id] || ''}
            onChange={(e) => handleFacultyChange(row.id, e.target.value)}
          >
            <option value="">Select Faculty</option>
            {Array.isArray(facultyList) && facultyList.length > 0 ? (
              facultyList.map((faculty) => (
                <option key={faculty.facultyId} value={faculty.facultyId}>
                  {faculty.facultyName}
                </option>
              ))
            ) : (
              <option>No faculty available</option>
            )}
          </select>
        </div>
      ),
    },
  ];
  // Store selected faculty in state
  const handleFacultyChange = (rowId, selectedFacultyId) => {
    setRowFacultyAssignments((prevAssignments) => ({
      ...prevAssignments,
      [rowId]: parseInt(selectedFacultyId), // Ensure the faculty ID is an integer
    }));
  };
  const handleSubmitFacultyAssignments = async () => {
    const token = localStorage.getItem('token');
    const updateData = records
      .filter((row) => rowFacultyAssignments[row.id])
      .map((row) => ({
        id: row.id,
        reAssfacultyId: rowFacultyAssignments[row.id],
        additionalFacultyId: rowFacultyAssignments[row.id],
      }));

    const data = {
      examId: examId,
      subjectId: subjectId,
      updateData: updateData,
    };

    try {
      const response = await axios.post(`${apiUrl}/api/reAssessment`, data, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
      });

      if (response.status === 200) {
        toast.success('Reassessment faculty allocated successfully.');
        fetchRecords();
        setTimeout(() => {
          navigate(-1);
        }, 3000);

        setRowFacultyAssignments({});
      } else {
        toast.error('Failed to allocate reassessment faculty.');
      }
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      toast.error(error.response.data.message);
    }
  };

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac10="active">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  View Reassessment
                </li>
                <li className="breadcrumb-item active">
                  View Re-Reassessment list{' '}
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          <div className="row">
            <div className="container">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    name="totalMarks"
                    placeholder="Search"
                    title="Search within table"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records}
                  progressPending={loading}
                  className="custom-table"
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
              <div className="text-end mt-2">
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitFacultyAssignments}
                >
                  Allocate
                </button>
              </div>
            </div>
          </div>
          <Tooltip id="my-tooltip" />
        </AdminLayout>
      </main>
    </div>
  );
}
